export default __webpack_public_path__ + "static/char-s-13-jp-4822498f9cf856ba034946a4ee107e9c.webp";